import request from '@/utils/request'

const url = '/home/address/'
const api = {
  getAddressList (data) {
    return request({
      url: url + 'getAddressList',
      method: 'post',
      data
    })
  },
  saveAddress (data) {
    return request({
      url: url + 'saveAddress',
      method: 'post',
      data
    })
  },
  delAddress (data) {
    return request({
      url: url + 'delAddress',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/address.js